import * as React from "react";
import { mapReadyProps } from "./Utils/MapReady";
import EsriLoaderReact from "esri-loader-react";
import { buildFormMap, formModulesToLoad } from "./Utils/BuildFormMap";
import MapComponents from "./business-objects/MapComponents";

export interface FormEsriLoaderReactProps {
  component: any;
  isNightmode: boolean;
  mapContainerClassName?: string;
  onError?: (error: Error, errorInfo: any) => void;
  onReady?: (mapComponents: MapComponents) => void;
}

export default class FormEsriLoaderReact extends React.Component<FormEsriLoaderReactProps> {
  onReady = (mapReadyProps: mapReadyProps) => {
    const mapComponents = buildFormMap(
      mapReadyProps,
      this.props.component.featureLayers,
      this.props.component.geocodeServer,
      this.props.isNightmode
    );

    if (this.props.onReady) {
      this.props.onReady(mapComponents);
    }
  };

  onError = (error: Error, errorInfo: any) => {
    console.error(error);
    this.props.onError && this.props.onError(error, errorInfo);
  };

  render() {
    const options = {
      url: this.props.component.arcgisUrl
    };
    return (
      <div>
        <link
          rel="stylesheet"
          href={`${this.props.component.arcgisUrl}esri/themes/${this.props.isNightmode ? "dark" : "light"}/main.css`}
        />
        <EsriLoaderReact
          options={options}
          modulesToLoad={formModulesToLoad}
          onReady={this.onReady}
          onError={this.onError}
          mapContainerClassName={this.props.mapContainerClassName}
          
        />
      </div>
    );
  }
}
